import { Button, Image, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useUserFilesTabs } from "./UserFilesTabsContext";
import { Link, useLocation } from "react-router-dom";
import styles from "./Onboardingupdate.module.scss";
import { API_URL, fetcher } from "../../../utils/fetcher";
import useSWR from "swr";
import { AppModal } from "../../../components/common";

type Option = { label: string; value: string };

const yesNo: Option[] = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];


export default function UserDetailsModal() {
  const { userDetailsModal, setUserDetailsModal,setUserDetails } = useUserFilesTabs();
  const location = useLocation();
  const clientId = location?.pathname?.split("/")[3];

  
  const { data: eventData } =
    useSWR(
      API_URL + `/onetime/get/${clientId}`,
      fetcher,
      {
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        revalidateOnMount: true,
      }
    );
    setUserDetails(eventData)

  console.log(eventData,"eventData");
  const valueData = eventData?.data
  return (
    <AppModal
      className="userDetailsModal"
      title={`${clientId} Details (User Details)`}
      open={userDetailsModal}
      onCancel={() => setUserDetailsModal(false)}
    >
        
       <section className={styles.content}>
          {/* Card 1 */}
          <div className={styles.card}>
            <p className={styles.cardKicker}>Basic Details</p>

            <div className={styles.field}>
              <label className={styles.label}>Age</label>
              <input
                className={styles.input}
                placeholder="Please enter your age"
                inputMode="numeric"
                readOnly
                value={valueData?.basicInfo?.age}
              />
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Gender/ preferred pronouns</label>
              <div className={styles.selectWrap}>
                <Select
                  className={styles.figmaSelect}
                  getPopupContainer={(triggerNode) =>
                    triggerNode.parentElement!
                  }
                  placeholder="Select your gender"
                  value={valueData?.basicInfo?.gender}
                  disabled
                  
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Profession</label>
              <input
                className={styles.input}
                placeholder="Please enter your profession"
               disabled
                value={valueData?.basicInfo?.profession}
              />
            
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Marital status</label>
              <div className={styles.selectWrap}>
                <Select
                  className={styles.figmaSelect}
                  getPopupContainer={(triggerNode) =>
                    triggerNode.parentElement!
                  }
                  placeholder="Select marital status"
                 value={valueData?.basicInfo?.maritalStatus}
                  disabled
                />
              
              </div>
            </div>
          </div>

          {/* Card 2 */}
         
            <p className={styles.cardKicker}>
              Therapy &amp; Wellness Check-in
            </p>

            <div className={styles.questionRow}>
              <label className={styles.question}>
                Have you ever been in therapy before?
              </label>

              <div
                className={styles.pillGroup}
                role="radiogroup"
                aria-label="Therapy before"
              >
                {yesNo.map((o) => {
                  const isActive = (valueData?.therapyHistory?.previousTherapy ?? "No") === o.value;
                    

                  return (
                    <button
                      key={o.value}
                      type="button"
                      role="radio"
                      aria-checked={isActive}
                      className={`${styles.pillBtn} ${
                        isActive ? styles.pillActive : ""
                      }`}
                      disabled
                    >
                      {o.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label}>
                Habits that you want to work on
              </label>
              <input
                className={styles.input}
                placeholder="Please List Habits You Wish to Improve"
                 value={valueData?.therapyHistory?.habitsToWorkOn}
                readOnly
               
              />
            </div>

            <div className={styles.field}>
              <label className={styles.label}>
                Do you have any diagnosed physical/ mental ailments?
              </label>
              <input
                className={styles.input}
                placeholder="Please Mention Any Diagnosed Conditions"
                value={valueData?.therapyHistory?.diagnosedAilments}
                readOnly
              />
            
            </div>

            <div className={styles.field}>
              <label className={styles.label}>
                Are you currently under any Medication?
              </label>
              <input
                className={styles.input}
                placeholder="Please List Current Medications, If Any"
                value={valueData?.therapyHistory?.currentMedication}
               disabled
              />
            </div>

            <div className={styles.field}>
              <label className={styles.label}>
                Please check any symptoms you have experienced recently
              </label>
              <div className={styles.selectWrap}>
                <Select
                  className={`${styles.figmaSelect} ${styles.figmaSelect_alt}`}
                  mode="multiple"
                  allowClear
                  getPopupContainer={(triggerNode) =>
                    triggerNode.parentElement!
                  }
                  placeholder="Select or type symptoms"
                  value={valueData?.therapyHistory?.symptoms}
                  disabled
                 
                />
               
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label}>
                Goals in therapy/ expectations from therapy (What do you hope to
                gain from this evaluation and/or counseling?)
              </label>
              <input
                className={styles.input}
                placeholder="Please Enter your therapy goals"
                value={valueData?.therapyHistory?.therapyGoals}
                disabled
              />
             
            </div>
          {/* </div> */}

          {/* Card 3 */}
          {/* <div className={styles.card}> */}
            <p className={styles.cardKicker}>Personal Safety</p>

            <div className={styles.field}>
              <label className={styles.label}>
                Have you ever found yourself struggling with thoughts of
                self-harm/death?
              </label>

              <div
                className={styles.pillGroup}
                role="radiogroup"
                aria-label="Self harm thoughts"
              >
                {yesNo.map((o) => {
                  const isActive = (valueData?.personalSafety?.selfHarmThoughts ?? "No") === o.value;
                    

                  return (
                    <button
                      key={o.value}
                      type="button"
                      role="radio"
                      aria-checked={isActive}
                      className={`${styles.pillBtn} ${
                        isActive ? styles.pillActive : ""
                      }`}
                      disabled
                      
                    >
                      {o.label}
                    </button>
                  );
                })}
              {/* </div> */}
            
            </div>
 </div>
        </section>
    </AppModal>
  );
}
